import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\GetInvoiceChiftPaymentsController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceChiftPaymentsController.php
* @route '/api/invoicing/{invoice}/chift-payments'
*/
const GetInvoiceChiftPaymentsController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoiceChiftPaymentsController.url(args, options),
    method: 'get',
})

GetInvoiceChiftPaymentsController.definition = {
    methods: ["get","head"],
    url: '/api/invoicing/{invoice}/chift-payments',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Invoice\GetInvoiceChiftPaymentsController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceChiftPaymentsController.php
* @route '/api/invoicing/{invoice}/chift-payments'
*/
GetInvoiceChiftPaymentsController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return GetInvoiceChiftPaymentsController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\GetInvoiceChiftPaymentsController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceChiftPaymentsController.php
* @route '/api/invoicing/{invoice}/chift-payments'
*/
GetInvoiceChiftPaymentsController.get = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoiceChiftPaymentsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Invoice\GetInvoiceChiftPaymentsController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoiceChiftPaymentsController.php
* @route '/api/invoicing/{invoice}/chift-payments'
*/
GetInvoiceChiftPaymentsController.head = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetInvoiceChiftPaymentsController.url(args, options),
    method: 'head',
})

export default GetInvoiceChiftPaymentsController